
import { PureSwitch } from '@/components/form/Switch';
import { useGrid } from '@Components/Grid';

export default function TwoFactorAuthenticationFormatter({ info }) {
  const { events: { handleUpdate2FA } } = useGrid()
  const id = info.row.original.twoFactorAuthentication?.id

  return <PureSwitch name="_" value={id} disabled={!id} onChange={() => handleUpdate2FA(id)} />
}
